import React from "react";
import CountUp from "react-countup";
import { FaCode } from "react-icons/fa";

const LeetCodeCard = () => {
  const stats = {
    totalSolved: 181,
    easy: 52,
    medium: 99,
    hard: 30,
    profileUrl: "https://leetcode.com/u/praveen_304/"
  };

  // Circular progress calculations (Radius = 46, Circumference ~ 289)
  const radius = 46;
  const circumference = 2 * Math.PI * radius;
  // Let the circular ring visually show ~70% completion aesthetic
  const strokeDashoffset = circumference - (circumference * 0.72);

  return (
    <div className="activity-card leetcode-card">
      <div className="activity-card-header">
        <div className="activity-card-title-group">
          <span className="card-icon leetcode-icon">
            <FaCode />
          </span>
          <h2 className="activity-card-title">📊 LeetCode Stats</h2>
        </div>
        <span className="platform-tag leetcode-tag">@praveen_304</span>
      </div>

      <div className="card-main-stat">
        <div className="circular-progress-wrapper">
          <svg className="circular-progress-svg" viewBox="0 0 110 110">
            <defs>
              <linearGradient id="leetcodeGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#ffa116" />
                <stop offset="100%" stopColor="#f59e0b" />
              </linearGradient>
            </defs>
            {/* Background Track */}
            <circle
              className="circle-bg"
              cx="55"
              cy="55"
              r={radius}
              strokeWidth="8"
            />
            {/* Animated Ring */}
            <circle
              className="circle-progress"
              cx="55"
              cy="55"
              r={radius}
              strokeWidth="8"
              strokeDasharray={circumference}
              strokeDashoffset={strokeDashoffset}
              strokeLinecap="round"
            />
          </svg>
          <div className="circle-inner-content">
            <span className="circle-number">
              <CountUp end={stats.totalSolved} duration={2} enableScrollSpy />
            </span>
            <span className="circle-label">Problems Solved</span>
          </div>
        </div>
      </div>

      <div className="difficulty-breakdown">
        {/* Easy */}
        <div className="diff-item easy">
          <div className="diff-info">
            <span className="diff-name">Easy</span>
            <span className="diff-count">
              <strong>{stats.easy}</strong>
              <span className="diff-pct"> (28.7%)</span>
            </span>
          </div>
          <div className="diff-bar-track">
            <div
              className="diff-bar-fill easy-fill"
              style={{ width: `${(stats.easy / stats.totalSolved) * 100}%` }}
            />
          </div>
        </div>

        {/* Medium */}
        <div className="diff-item medium">
          <div className="diff-info">
            <span className="diff-name">Medium</span>
            <span className="diff-count">
              <strong>{stats.medium}</strong>
              <span className="diff-pct"> (54.7%)</span>
            </span>
          </div>
          <div className="diff-bar-track">
            <div
              className="diff-bar-fill medium-fill"
              style={{ width: `${(stats.medium / stats.totalSolved) * 100}%` }}
            />
          </div>
        </div>

        {/* Hard */}
        <div className="diff-item hard">
          <div className="diff-info">
            <span className="diff-name">Hard</span>
            <span className="diff-count">
              <strong>{stats.hard}</strong>
              <span className="diff-pct"> (16.6%)</span>
            </span>
          </div>
          <div className="diff-bar-track">
            <div
              className="diff-bar-fill hard-fill"
              style={{ width: `${(stats.hard / stats.totalSolved) * 100}%` }}
            />
          </div>
        </div>
      </div>

      <a
        href={stats.profileUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="activity-card-btn"
        aria-label="View Praveen Kumar's LeetCode Profile"
      >
        View LeetCode Profile →
      </a>
    </div>
  );
};

export default LeetCodeCard;
